import { Link, useLocation } from "react-router-dom";
import BrandLogo from "@/brand/BrandLogo";
import BRAND from "@/brand/brand";

export default function Footer() {
  const { pathname } = useLocation();
  if (pathname === "/scan") return null;
  if (pathname.startsWith("/p/")) return null;

  return (
    <footer className="border-t border-slate-200 bg-white" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-12">
        <div className="flex flex-col md:flex-row justify-between gap-8">
          <div className="max-w-sm">
            <div className="mb-3">
              <BrandLogo variant="wordmark" imgClass="h-9 w-auto object-contain" markClass="w-8 h-8" textClass="text-[17px]" />
              <div className="mt-1 text-xs font-semibold uppercase tracking-[0.18em] text-slate-400">
                Business Scanner
              </div>
            </div>
            <p className="text-sm text-slate-500 leading-relaxed">
              An AI business detective that scans your online presence to uncover the revenue and
              opportunities your business may be missing. Built for local businesses in Hawaii and beyond.
            </p>
          </div>
          <div className="flex gap-10 sm:gap-16 text-sm flex-wrap">
            <div className="space-y-2.5">
              <p className="font-heading font-semibold text-slate-900">Product</p>
              <Link to="/scan" className="block text-slate-500 hover:text-slate-900 transition-colors">Run a scan</Link>
              <Link to="/dashboard" className="block text-slate-500 hover:text-slate-900 transition-colors">Dashboard</Link>
              <Link to="/proposals" className="block text-slate-500 hover:text-slate-900 transition-colors">Proposals</Link>
              <Link to="/account" className="block text-slate-500 hover:text-slate-900 transition-colors">Account</Link>
            </div>
            <div className="space-y-2.5">
              <p className="font-heading font-semibold text-slate-900">Legal</p>
              <Link to="/privacy" className="block text-slate-500 hover:text-slate-900 transition-colors" data-testid="footer-privacy">Privacy Policy</Link>
              <Link to="/terms" className="block text-slate-500 hover:text-slate-900 transition-colors" data-testid="footer-terms">Terms of Service</Link>
              <Link to="/refund-policy" className="block text-slate-500 hover:text-slate-900 transition-colors" data-testid="footer-refund">Refund Policy</Link>
              <Link to="/ai-disclaimer" className="block text-slate-500 hover:text-slate-900 transition-colors" data-testid="footer-ai">AI Disclaimer</Link>
            </div>
          </div>
        </div>
        <div className="mt-10 pt-6 border-t border-slate-100 text-xs text-slate-400 leading-relaxed">
          © {new Date().getFullYear()} {BRAND.name}. Reports are AI-generated business assessments based on
          publicly available data. They are not financial, credit, or legal advice and do not guarantee results.
        </div>
      </div>
    </footer>
  );
}
